// Sector-specific module configurations

export const SECTOR_MODULES = {
  pharmacy: {
    name: 'Pharmacy',
    icon: '💊',
    color: 'blue',
    modules: ['dashboard', 'products', 'pos', 'sales', 'customers', 'suppliers', 'expenses', 'reports']
  },
  salon: {
    name: 'Salon & Spa',
    icon: '✂️',
    color: 'pink',
    modules: ['dashboard', 'services', 'appointments', 'customers', 'expenses', 'reports']
  },
  restaurant: {
    name: 'Restaurant',
    icon: '🍽️',
    color: 'orange',
    modules: ['dashboard', 'tables', 'products', 'pos', 'sales', 'customers', 'reports']
  },
  mobile_shop: {
    name: 'Mobile Shop',
    icon: '📱',
    color: 'purple',
    modules: ['dashboard', 'branches', 'products', 'product-assignment', 'stock-transfer', 'warranties', 'repairs', 'purchases', 'suppliers', 'pos', 'sales', 'customers', 'customer-dues', 'low-stock', 'reports']
  },
  computer_shop: {
    name: 'Computer Shop',
    icon: '🖥️',
    color: 'cyan',
    modules: ['dashboard', 'branches', 'products', 'product-assignment', 'stock-transfer', 'warranties', 'purchases', 'repairs', 'pos', 'sales', 'customers', 'suppliers', 'customer-dues', 'low-stock', 'expenses', 'reports']
  },
  grocery: {
    name: 'Grocery',
    icon: '🛒',
    color: 'green',
    modules: ['dashboard', 'products', 'offers', 'pos', 'sales', 'suppliers', 'customers', 'expenses', 'reports']
  },
  clinic: {
    name: 'Clinic',
    icon: '🏥',
    color: 'red',
    modules: ['dashboard', 'doctors', 'patients', 'appointments', 'services', 'expenses', 'reports']
  },
  electronics: {
    name: 'Electronics',
    icon: '💻',
    color: 'indigo',
    modules: ['dashboard', 'products', 'warranties', 'returns', 'repairs', 'pos', 'sales', 'customers', 'suppliers', 'reports']
  },
  fashion: {
    name: 'Fashion',
    icon: '👗',
    color: 'pink',
    modules: ['dashboard', 'products', 'variants', 'offers', 'pos', 'sales', 'customers', 'reports']
  },
  stationery: {
    name: 'Stationery',
    icon: '📚',
    color: 'yellow',
    modules: ['dashboard', 'books', 'products', 'pos', 'sales', 'customers', 'suppliers', 'reports']
  },
  hardware: {
    name: 'Hardware',
    icon: '🔧',
    color: 'gray',
    modules: ['dashboard', 'products', 'bulk-pricing', 'pos', 'sales', 'suppliers', 'customers', 'expenses', 'reports']
  },
  furniture: {
    name: 'Furniture',
    icon: '🛋️',
    color: 'brown',
    modules: ['dashboard', 'products', 'custom-orders', 'pos', 'sales', 'customers', 'expenses', 'reports']
  },
  garage: {
    name: 'Garage',
    icon: '🚗',
    color: 'blue',
    modules: ['dashboard', 'vehicles', 'repairs', 'services', 'customers', 'expenses', 'reports']
  },
  wholesale: {
    name: 'Wholesale',
    icon: '📦',
    color: 'teal',
    modules: ['dashboard', 'products', 'tier-pricing', 'purchase-orders', 'goods-receipts', 'offers', 'pos', 'sales', 'suppliers', 'customers', 'reports']
  },
  ecommerce: {
    name: 'E-commerce',
    icon: '🛍️',
    color: 'purple',
    modules: ['dashboard', 'products', 'online-orders', 'sales', 'customers', 'reports']
  },
  real_estate: {
    name: 'Real Estate',
    icon: '🏘️',
    color: 'green',
    modules: ['dashboard', 'properties', 'customers', 'expenses', 'reports']
  },
  cnf: {
    name: 'CNF (C&F)',
    icon: '🚢',
    color: 'blue',
    modules: ['dashboard', 'shipments', 'jobs', 'billing', 'documents', 'transport', 'cnf-reports']
  }
};

// Module to route mapping
export const MODULE_ROUTES = {
  dashboard: { path: '', label: 'Dashboard' },
  branches: { path: '/branches', label: 'Branches' },
  'product-assignment': { path: '/product-assignment', label: 'Product Assignment' },
  'stock-transfer': { path: '/stock-transfer', label: 'Stock Transfer' },
  products: { path: '/products', label: 'Products' },
  services: { path: '/services', label: 'Services' },
  appointments: { path: '/appointments', label: 'Appointments' },
  repairs: { path: '/repairs', label: 'Repairs' },
  tables: { path: '/tables', label: 'Tables' },
  pos: { path: '/pos', label: 'POS' },
  sales: { path: '/sales', label: 'Sales' },
  customers: { path: '/customers', label: 'Customers' },
  'customer-dues': { path: '/customer-dues', label: 'Customer Dues' },
  suppliers: { path: '/suppliers', label: 'Suppliers' },
  expenses: { path: '/expenses', label: 'Expenses' },
  reports: { path: '/reports', label: 'Reports' },
  doctors: { path: '/doctors', label: 'Doctors' },
  patients: { path: '/patients', label: 'Patients' },
  vehicles: { path: '/vehicles', label: 'Vehicles' },
  properties: { path: '/properties', label: 'Properties' },
  offers: { path: '/offers', label: 'Offers' },
  variants: { path: '/variants', label: 'Variants' },
  warranties: { path: '/warranties', label: 'Warranties' },
  returns: { path: '/returns', label: 'Returns' },
  books: { path: '/books', label: 'Books' },
  'bulk-pricing': { path: '/bulk-pricing', label: 'Bulk Pricing' },
  'custom-orders': { path: '/custom-orders', label: 'Custom Orders' },
  'tier-pricing': { path: '/tier-pricing', label: 'Tier Pricing' },
  'purchase-orders': { path: '/purchase-orders', label: 'Purchase Orders' },
  'goods-receipts': { path: '/goods-receipts', label: 'Goods Receipts' },
  'online-orders': { path: '/online-orders', label: 'Online Orders' },
  components: { path: '/components', label: 'Components' },
  'job-cards': { path: '/job-cards', label: 'Job Cards' },
  'device-history': { path: '/device-history', label: 'Device History' },
  purchases: { path: '/purchases', label: 'Purchases' },
  'low-stock': { path: '/low-stock', label: 'Low Stock Alerts' },
  shipments: { path: '/shipments', label: 'Shipments' },
  jobs: { path: '/jobs', label: 'Job Files' },
  billing: { path: '/billing', label: 'Billing' },
  documents: { path: '/documents', label: 'Documents' },
  transport: { path: '/transport', label: 'Transport' },
  'cnf-reports': { path: '/cnf-reports', label: 'CNF Reports' }
};

export const getSectorModules = (businessType) => {
  return SECTOR_MODULES[businessType] || SECTOR_MODULES.pharmacy;
};

export const isSectorAllowed = (businessType, module) => {
  const sectorConfig = SECTOR_MODULES[businessType];
  if (!sectorConfig) return false;
  return sectorConfig.modules.includes(module);
};
